
import {UIGamePopupController} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupController.ts'
import {GameStateEnums} from '../../../../../shared/GameEnums.ts'
import {UIMDeviceHandler} from '../../ui_html/UIMDeviceHandler.ts'
import {type TranslationObject} from '@colonist/i18n'

export class UIMGamePopupController extends UIGamePopupController {
    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums): void {
        super.onEvent(data, eventType)
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.FloatingNotification: this.showFloatingNotification(data)
                break
            default:
                break
        }
    }

    // eslint-disable-next-line class-methods-use-this
    private showFloatingNotification(message: TranslationObject): void {
        UIMDeviceHandler.showNotification(message)
    }
}
